import * as Yup from 'yup';

export const FormSchema = () =>
  Yup.object().shape({
    lastname: Yup.string().required(),
    uhpms: Yup.string().required(),
  });
